// First-party pageview beacon. Counts traffic in our own database so the admin Network overview shows
// real numbers on every site, including the six that have no GA4 property.
//
// No cookies and no stored identifier: the server derives a visitor hash that rotates daily and never
// keeps the IP, so this needs no consent banner of its own and runs regardless of the marketing choice.
// It is fire-and-forget: a failed beacon must never affect the page.
const API = process.env.REACT_APP_BACKEND_URL || '';

let lastPath = null;

export function trackPageview(site, path) {
  try {
    if (!site) return;
    const p = path || window.location.pathname;
    if (p === lastPath) return;        // React re-renders should not inflate the count
    lastPath = p;
    // Previews and local runs would pollute the numbers with our own testing.
    const h = (window.location.hostname || '').toLowerCase();
    if (h === 'localhost' || h.endsWith('.localhost') || h.endsWith('.vercel.app') || h === '127.0.0.1') return;

    const body = JSON.stringify({ site, path: p, ref: document.referrer || '' });
    // sendBeacon survives the page being closed mid-request, which a fetch does not.
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/api/pv`, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(`${API}/api/pv`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body, keepalive: true }).catch(() => {});
    }
  } catch {
    /* never let analytics break a page */
  }
}
